import {defineSlotRecipe} from '@chakra-ui/react'
export const menuTheme = defineSlotRecipe({
  slots: ['item', 'content'],
  base: {item: {borderRadius: 'sm'}, content: {paddingInline: '2'}},
})
